import React from 'react';

import { Panel, PanelBreak, Panels, spacing } from '~/src/dash/publicaUI';
import { IDemandSettingsComponent } from '~/src/dash/views/demand-settings/demand-settings-view';

export const BiddersDemandSourceSettings = () => {
  return (
    <Panels
      max
      vertical
      relative
      largeHorizontalPadding
      verticalPadding
      style={{ rowGap: spacing.medium }}
    >
      <Panel>
        {/* TODO: REFACTOR THIS COMPONENT AT A LATER DATE */}
        <IDemandSettingsComponent />
      </Panel>
      <PanelBreak height={spacing.large} />
    </Panels>
  );
};
